module.exports = __webpack_public_path__ + "img/火麻仁.2bdb7500.jpg";